import { getCoreDataSecurityAccessExplainerByObjectIdSlice } from './get';

export const {
	requestGetCoreDataSecurityAccessExplainerByObjectId,
	resetGetCoreDataSecurityAccessExplainerByObjectId
} =
    getCoreDataSecurityAccessExplainerByObjectIdSlice.asyncActionCreators;
